import { TOP_GAINERS_LOSERS, TOP_GAINERS_LOSERS_STREAM, } from "../../../interface/iTopGainersLosers";
import { drivingMarketStreamingUpdate } from "@domains/features/Markets/Equity/utils/streamingUpdate";
let initState = {
    data: [],
};
const topGainersLosers = (state = initState, action) => {
    switch (action.type) {
        case TOP_GAINERS_LOSERS:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case TOP_GAINERS_LOSERS_STREAM:
            return Object.assign(Object.assign({}, state), { data: drivingMarketStreamingUpdate(state.data, action.payload.qouteStream) });
        default:
            return state;
    }
};
export default topGainersLosers;
